// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-style-5 input[type="text"],
.form-style-5 input[type="date"],
.form-style-5 input[type="datetime"],
.form-style-5 input[type="email"],
.form-style-5 input[type="number"],
.form-style-5 input[type="search"],
.form-style-5 input[type="time"],
.form-style-5 input[type="url"],
.form-style-5 textarea,
.form-style-5 select {
   background: rgba(255, 255, 255, .1);
   border: none;
   border-radius: 4px;
   font-size: 15px;
   margin: 0;
   outline: 0;
   padding: 10px;
   width: 100%;
   box-sizing: border-box;
   -webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
   background-color: #e8eeef;
   color: #003284;
   box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
   margin-bottom: 30px;
}

.form-style-5 fieldset {
   border: none;
}

.form-style-5 legend {
   font-size: 1.4em;
   margin-bottom: 10px;
}

.form-style-5 label {
   display: block;
   margin-bottom: 8px;
}

.div-company {
   padding: 10px 20px;
}

input, textarea, select {
   background: transparent;
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   display: block;
   font-size: 13px;
   outline: none;
   padding: 5px;
   resize: none;
}

td, th {
   text-align: left;
   padding: 8px;
}

.input_text {
   width: 230px;
   color: #777;
   font-size: 14px;
   font-weight: 400;
}

#form {
   margin-top: 20px;
}

.select-type {
   width: 40%;
}

.date {
   background: transparent;
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   display: inline-block;
   font-size: 13px;
   outline: none;
   padding: 5px;
   resize: none;
   width: 40%;
}

.text_to {
   margin: 0 15px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-dialog-content {
   display: block;
   margin: 5px -15px;
   font-size: 16px;
}
select{
   width: 100px;
   text-overflow: inherit;
}

input[type=date]::-webkit-inner-spin-button,
input[type=date]::-webkit-outer-spin-button {
   -webkit-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/advance-search-dialog/advance-search-dialog.component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG,mCAAmC;GACnC,YAAY;GACZ,kBAAkB;GAClB,eAAe;GACf,SAAS;GACT,UAAU;GACV,aAAa;GACb,WAAW;GACX,sBAAsB;GACtB,8BAA8B;GAC9B,2BAA2B;GAC3B,yBAAyB;GACzB,cAAc;GAEd,6CAA6C;GAC7C,mBAAmB;AACtB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,uBAAuB;GACvB,yBAAyB;GACzB,kBAAkB;GAClB,cAAc;GACd,eAAe;GACf,aAAa;GACb,YAAY;GACZ,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,YAAY;AACf;;AAEA;GACG,YAAY;GACZ,WAAW;GACX,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,uBAAuB;GACvB,yBAAyB;GACzB,kBAAkB;GAClB,qBAAqB;GACrB,eAAe;GACf,aAAa;GACb,YAAY;GACZ,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,cAAc;GACd,iBAAiB;GACjB,eAAe;AAClB;AACA;GACG,YAAY;GACZ,sBAAsB;AACzB;;AAEA;;GAEG,wBAAwB;AAC3B","sourcesContent":[".form-style-5 input[type=\"text\"],\n.form-style-5 input[type=\"date\"],\n.form-style-5 input[type=\"datetime\"],\n.form-style-5 input[type=\"email\"],\n.form-style-5 input[type=\"number\"],\n.form-style-5 input[type=\"search\"],\n.form-style-5 input[type=\"time\"],\n.form-style-5 input[type=\"url\"],\n.form-style-5 textarea,\n.form-style-5 select {\n   background: rgba(255, 255, 255, .1);\n   border: none;\n   border-radius: 4px;\n   font-size: 15px;\n   margin: 0;\n   outline: 0;\n   padding: 10px;\n   width: 100%;\n   box-sizing: border-box;\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   background-color: #e8eeef;\n   color: #003284;\n   -webkit-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;\n   box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;\n   margin-bottom: 30px;\n}\n\n.form-style-5 fieldset {\n   border: none;\n}\n\n.form-style-5 legend {\n   font-size: 1.4em;\n   margin-bottom: 10px;\n}\n\n.form-style-5 label {\n   display: block;\n   margin-bottom: 8px;\n}\n\n.div-company {\n   padding: 10px 20px;\n}\n\ninput, textarea, select {\n   background: transparent;\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   display: block;\n   font-size: 13px;\n   outline: none;\n   padding: 5px;\n   resize: none;\n}\n\ntd, th {\n   text-align: left;\n   padding: 8px;\n}\n\n.input_text {\n   width: 230px;\n   color: #777;\n   font-size: 14px;\n   font-weight: 400;\n}\n\n#form {\n   margin-top: 20px;\n}\n\n.select-type {\n   width: 40%;\n}\n\n.date {\n   background: transparent;\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   display: inline-block;\n   font-size: 13px;\n   outline: none;\n   padding: 5px;\n   resize: none;\n   width: 40%;\n}\n\n.text_to {\n   margin: 0 15px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-dialog-content {\n   display: block;\n   margin: 5px -15px;\n   font-size: 16px;\n}\nselect{\n   width: 100px;\n   text-overflow: inherit;\n}\n\ninput[type=date]::-webkit-inner-spin-button,\ninput[type=date]::-webkit-outer-spin-button {\n   -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
